import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Divider,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import agentFlowIzziLogo from '../assets/AgentFlowIZZI.svg'
import { useConfig } from '../contexts/ConfigContext'

const AboutModal = ({ open, onClose }) => {
  const config = useConfig()

  const buildInfo = config?.build || {}
  const commit = buildInfo.commit || 'unknown'
  const buildDate = buildInfo.date || 'unknown'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{
        m: 0,
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        bgcolor: 'primary.main'
      }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: 'primary.contrastText',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', p: 0 }}>
        <Box sx={{
          bgcolor: 'primary.main',
          py: 4,
          px: 3,
          mb: 3
        }}>
          <img
            src={agentFlowIzziLogo}
            alt="AgentFlow IZZI"
            style={{
              maxWidth: '100%',
              height: 'auto',
              maxHeight: '120px'
            }}
          />
        </Box>

        <Box sx={{ px: 3, pb: 4 }}>

        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          AgentFlow is an intelligent automation platform that streamlines business processes
          through AI-powered agents. Experience seamless workflow automation with advanced
          natural language processing and smart decision-making capabilities.
        </Typography>

        <Divider sx={{ my: 2 }} />

        <Typography variant="body2" sx={{ mb: 2, fontWeight: 500 }}>
          Developed by WeFi Technology Group
        </Typography>

        <Box sx={{ mt: 3, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
          <Typography variant="caption" display="block" sx={{ color: 'text.secondary', mb: 0.5 }}>
            Version Information
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              cursor: 'pointer',
              userSelect: 'none'
            }}
            onClick={() => {
              const baseUrl = window.location.origin
              const basePath = config?.basePath || ''
              window.open(`${baseUrl}${basePath}/docs/RELEASE_NOTES.md`, '_blank')
            }}
          >
            Build: {commit.substring(0, 8)}
          </Typography>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
            Date: {buildDate}
          </Typography>
        </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default AboutModal
